import { css } from 'styled-components'

const extendStylesDropdownResultAuth = css`
    width: 177px;
`

export {
    extendStylesDropdownResultAuth
}